// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"9559a895","433":"47a6806f","537":"79dc3233"}[chunkId] + ".chunk.js";
};